import type { Theme, WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      flex: 1,
    },
    passwordRules: {
      ...theme.fonts.h5,
      display: "flex",
      alignItems: "start",
      flexDirection: "column",
      color: theme.colors.textDefault,
    },
    modalDetailsText: {
      ...theme.fonts.p2,
      padding: 0,
      marginLeft: "24px",
      textAlign: "left",
      marginTop: "8px",
      marginBottom: "16px",
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
